// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hrsata-jobs .face[data-v-7a631ead]{position:absolute;top:-120px;right:20px}@media only screen and (min-width:1200px){.hrsata-jobs .face[data-v-7a631ead]{top:-120px;right:60px}}", ""]);
// Exports
module.exports = exports;
